import { render, staticRenderFns } from "./FormHowMuch.vue?vue&type=template&id=6d4da1a3"
import script from "./FormHowMuch.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHowMuch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports